import appEvents from 'app/core/app_events';
import _ from 'lodash';
import coreModule from '../../core_module';
// import appEvents from 'app/core/app_events';
import config from 'app/core/config';
import store from 'app/core/store';
import $ from 'jquery';
import impressionSrv from 'app/core/services/impression_srv';

export class SidepaneCtrl {
  tree: any;
  collapsed = false;
  sensors = {};
  currentExperimentExpanded: false;
  mainLinks: any;
  bottomNav: any;
  isSignedIn: boolean;
  loading = true;
  searchTerm: any;
  searchInProgress = false;
  searchError: any;
  lastBackendSearchTerm: any;
  showSensorsWarning = false;
  showLoadMoreExperimentsButton = false;
  loadMoreExperimentsButtonText = 'Load more...';
  matlabPluginUrl: string;
  loginUrl = '/login';
  experimentLoadLimit = 100;
  experimentLoadOffset = 0;

  /** @ngInject */
  constructor(
    private $q,
    private backendSrv,
    private dashboardSrv,
    private contextSrv,
    private $rootScope,
    private $location,
    private $window,
    private matlabPluginSrv,
    private experimentSrv,
    $timeout
  ) {
    this.isSignedIn = this.contextSrv.isSignedIn;

    this.collapsed = !this.isSignedIn || store.getBool(this.collapsedKey(), false);

    let navTree = _.cloneDeep(config.bootData.navTree);

    this.mainLinks = _.filter(navTree, item => !item.hideFromMenu);

    this.bottomNav = _.filter(navTree, item => item.hideFromMenu);

    if (contextSrv.user.orgCount > 1) {
      let profileNode = _.find(this.bottomNav, { id: 'profile' });
      if (profileNode) {
        profileNode.showOrgSwitcher = true;
      }
    }

    if (this.isSignedIn) {
      this.refresh();
    }

    $timeout(this.initMatlabUrl.bind(this), 50);

    appEvents.on('refresh-sidepane', this.refresh.bind(this));

    this.reactDragStart = this.reactDragStart.bind(this);
    this.reactDragEnd = this.reactDragEnd.bind(this);
  }

  initMatlabUrl() {
    if ($('body').hasClass('sidemenu-hidden')) {
      return;
    }

    this.matlabPluginSrv.getUrl().then(url => {
      this.matlabPluginUrl = url;

      // Create download MATLAB Plugin link in bottom menu
      let candidates = this.bottomNav.filter(navObject => navObject.text === 'Help');
      if (candidates.length > 0) {
        let helpItem = candidates[0];
        helpItem.children.push({
          text: 'Download MATLAB Plugin',
          icon: 'fa fa-download',
          url: url,
          target: '_blank',
        });
      }
    });
  }

  collapsedKey() {
    return 'sidepane.collapsed-' + config.bootData.user.orgId;
  }

  reactDragStart(e, channel, transferDataObject) {
    this.$rootScope.$broadcast('ANGULAR_DRAG_START', e, channel, transferDataObject);
  }

  reactDragEnd(e, channel) {
    this.$rootScope.$broadcast('ANGULAR_DRAG_END', e, channel);
  }

  onAdd = node => {
    this.$location.url(`/experiments/${node.id}/sensors/new`);
  };

  matlabPluginUrlClick = node => {
    this.$window.open(this.matlabPluginUrl);
  };

  doSearch(query) {
    this.searchTerm = query; // propagate to tree for sensor filter
    let filteredSearchTerm = query;

    // Don't do a back-end search if the only change since
    // the last search is front-end only "sensor:" filter
    let sensorFilter = query.match(/sensor:(\w+)/);
    if (sensorFilter) {
      filteredSearchTerm = query.replace(sensorFilter[0], '').trim();
      if (filteredSearchTerm === this.lastBackendSearchTerm) {
        return;
      }
    }

    this.searchError = null;
    this.loading = true;
    this.showLoadMoreExperimentsButton = false;
    this.searchInProgress = true;
    this.lastBackendSearchTerm = query.trim();

    let searchArgs = {
      limit: 100,
      query: query,
    };

    this.backendSrv.searchExperiments(searchArgs).then(results => {
      let tree = this.formatSearchResultsForTree(results);
      tree.children.unshift(this.activeExperimentNode());
      this.tree = tree;

      this.loading = false;
      this.searchInProgress = false;

      if (results.errorMessage && results.errorMessage.length > 0) {
        this.searchError = results.errorMessage;
      }
    });
  }

  formatSearchResultsForTree = results => {
    let tree = {
      id: 0,
      module: 'Experiments',
      type: 'folder',
      collapsed: false,
      children: [],
    };

    let formatHelper = experiment => {
      let node = {
        module: experiment.title,
        id: experiment.id,
        tags: experiment.tags,
        type: experiment.type,
        created: experiment.created,
        sensors: experiment.sensorIds,
      };
      return node;
    };

    tree.children = results.results.map(formatHelper);

    this.appendSensorNodes(tree);

    return tree;
  };

  clearSearch() {
    this.doSearch('');
  }

  onEdit = (node, parent?) => {
    if (node.type === 'experiment') {
      this.$location.url(`/experiments/edit/${node.id}`);
    } else if (node.type === 'folder') {
      this.$location.url(`/experiments/folders/edit/${node.id}`);
    } else if (node.type === 'sensor') {
      this.$location.url(`/sensors/edit/${node.id}?experimentId=${parent && parent.id}`);
    }
  };

  onView = node => {
    if (node.type !== 'experiment') {
      return;
    }

    this.backendSrv.getExperiment(node.id).then(exp => {
      this.loadFullDash(exp);
    });
  };

  handleExperimentTreeModification = changeEvent => {
    this.loading = true;

    this.backendSrv.updateExperimentTree(changeEvent).then(result => {
      this.loading = false;
    });
  };

  handleTreeUpdate = (newTree, changeEvent) => {
    if (!changeEvent) {
      return;
    }

    console.log(changeEvent);

    if (changeEvent.from.type !== 'sensor') {
      let serverChangeEvent = {
        fromId: changeEvent.from.id,
        toId: changeEvent.to.id,
        placement: changeEvent.placement,
      };

      this.handleExperimentTreeModification(serverChangeEvent);
    }
  };

  makeSensorNode(sensor) {
    let module = sensor.shortName;
    if (sensor.description) {
      module += ` - ${sensor.description}`;
    }
    return {
      module: module,
      shortName: sensor.shortName,
      description: sensor.description,
      type: 'sensor',
      leaf: true,
      id: sensor.id,
      databaseId: sensor.databaseId,
    };
  }

  makeSensorNodes(ids) {
    let nodes = ids.map(id => this.makeSensorNode(this.sensors[id]));
    nodes.sort((a, b) => {
      if (a.shortName.toLowerCase() > b.shortName.toLowerCase()) {
        return 1;
      } else if (a.shortName.toLowerCase() < b.shortName.toLowerCase()) {
        return -1;
      } else {
        return 0;
      }
    });
    return nodes;
  }

  appendSensorNodes(tree) {
    if (tree.type === 'experiment') {
      tree.collapsed = true;
      if (tree.sensors) {
        tree.children = this.makeSensorNodes(tree.sensors);
      }
    } else if (tree.children) {
      tree.children.forEach(child => this.appendSensorNodes(child));
    }
  }

  refresh() {
    this.loading = true;

    this.sensors = {};

    let limit = this.experimentLoadLimit;
    let offset = this.experimentLoadOffset;

    this.$q.all([this.backendSrv.getExperimentTree(offset, limit), this.backendSrv.searchSensors()]).then(values => {
      let [tree, sensors] = values;

      if (tree.children.length <= 0) {
        this.showLoadMoreExperimentsButton = false;
      }

      this.experimentSrv.setRootObjectCount(tree.children.length);

      for (var sensor of sensors) {
        this.sensors[sensor.id] = sensor;
      }

      this.appendSensorNodes(tree);
      tree.children.unshift(this.activeExperimentNode());

      this.tree = tree;

      this.loading = false;
      // The -1 is for the "Active experiment" node
      if (tree.children.length > 0 && tree.children.length - 1 < tree.total_count) {
        this.showLoadMoreExperimentsButton = true;
      }
    });
  }

  loadMoreExperiments() {
    this.loading = true;
    this.loadMoreExperimentsButtonText = 'Loading...';

    this.experimentLoadOffset = this.experimentLoadOffset + this.experimentLoadLimit;

    this.backendSrv.getExperimentTree(this.experimentLoadOffset, this.experimentLoadLimit).then(tree => {
      if (tree.children.length === 0) {
        this.showLoadMoreExperimentsButton = false;
        this.loading = false;
        alert('No more experiments to load.');
        return;
      }

      let currentCount = this.experimentSrv.getRootObjectCount();
      this.experimentSrv.setRootObjectCount(currentCount + tree.children.length);

      this.appendSensorNodes(tree);

      var treeCopy = Object.assign({}, this.tree);
      treeCopy.children.push(...tree.children);
      this.tree = treeCopy;
      this.loading = false;
      this.loadMoreExperimentsButtonText = 'Load more...';

      // The - 1 is for "Active experiment"
      this.showLoadMoreExperimentsButton = this.tree.children.length - 1 < tree.total_count;
    });
  }

  activeExperimentNode() {
    let activeExperiment = {
      id: -1,
      collapsed: true,
      module: 'Active experiment',
      type: 'experiment',
      children: this.makeSensorNodes(Object.keys(this.sensors)),
    };

    let experimentDetails = {
      module: 'Experiment details',
      type: 'experimentdetails',
      leaf: true,
    };
    activeExperiment.children.unshift(experimentDetails);

    let videoPanel = {
      module: 'Experiment video',
      type: 'video',
      leaf: true,
    };
    activeExperiment.children.unshift(videoPanel);

    return activeExperiment;
  }

  getLastDashUrl(exp) {
    return this.$q((resolve, reject) => {
      let lastDashUrl = impressionSrv.getLastDashUrl();
      if (lastDashUrl) {
        return resolve(lastDashUrl);
      }

      this.backendSrv.search().then(results => {
        let dashboards = results.filter(res => res.type === 'dash-db');
        if (dashboards.length === 0) {
          alert('Please create a dashboard first.');
        } else {
          resolve(dashboards[0]['url']);
        }
      });
    });
  }

  loadFullDash(exp) {
    var from = Math.round(exp.startedNs / Math.pow(10, 6));
    var to = Math.round(exp.stoppedNs / Math.pow(10, 6));

    this.getLastDashUrl(exp).then(lastDashUrl => {
      let url = `/e/${exp.id}${lastDashUrl}?from=${from}&to=${to}`;
      this.$location.url(url);
    });

    return false;
  }

  addPanelForCurrent(sensor) {
    this.dashboardSrv.dash.addSensorPanel(sensor.description, sensor.name);
  }

  addMetaPanelForCurrent() {
    this.dashboardSrv.dash.addExperimentMetaPanel();
  }

  addPanelFromExperiment(experiment, sensor) {
    var title = experiment.title + ' - ' + sensor.description;
    this.dashboardSrv.dash.addSensorPanel(title, sensor.name, experiment.id);
  }

  toggleCollapsed() {
    if (!this.isSignedIn) {
      return false;
    }

    this.collapsed = !this.collapsed;
    store.set(this.collapsedKey(), this.collapsed ? 'true' : 'false');
    return false;
  }

  toggleExpand(exp) {
    exp.expanded = !exp.expanded;
  }

  sidepaneClicked(event) {
    if (!this.collapsed) {
      return;
    }

    let id = event.target.getAttribute('id');
    if (id !== 'sidepane-contents') {
      return;
    }

    this.toggleCollapsed();
  }

  switchOrg() {
    this.$rootScope.appEvent('show-modal', {
      templateHtml: '<org-switcher dismiss="dismiss()"></org-switcher>',
    });
  }
}

export function sidepaneDirective() {
  return {
    restrict: 'E',
    templateUrl: 'public/app/core/components/sidepane/sidepane.html',
    controller: SidepaneCtrl,
    bindToController: true,
    controllerAs: 'ctrl',
    scope: {},
    link: function(scope, elem) {},
  };
}

var dateFilter = function() {
  return function(startedAt) {
    if (!startedAt) {
      return '';
    }

    var lpad = function(x) {
      return x < 10 ? '0' + x : x;
    };
    var date = new Date(startedAt);
    return date.getFullYear() + '-' + lpad(date.getMonth() + 1) + '-' + lpad(date.getDate());
  };
};

coreModule.directive('sidepane', sidepaneDirective);
coreModule.filter('isoDate', dateFilter);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/components/sidepane/sidepane.ts